/**
@description 设置路由路径
*/
import SinglePage from 'components/page/SinglePage'
import Recruitment from './recruitment'
import Jobs from './Jobs'
import JobDetail from './JobDetail'

export const recruitmentRouting = [
  {
    path: 'recruitment',
    name: '招贤纳士',
    component: Recruitment,
    indexRoute: {
      name: '职位招聘',
      component: Jobs,
      catname: 'jobRecruitment'
    },
    childRoutes: [
      {
        path: 'jobRecruitment',
        name: '职位招聘',
        component: Jobs
      },
      {
        path: 'jobDetail/:id',
        name: '职位详情',
        component: JobDetail
      },
      {
        path: 'office',
        name: '办公环境',
        title: '办公环境-招贤纳士',
        component: SinglePage
      },
      {
        path: 'trainingDevalopment',
        name: '培训发展',
        title: '培训发展-招贤纳士',
        component: SinglePage
      },
      {
        path: 'compensationAndBenefits',
        name: '薪酬福利',
        title: '薪酬福利-招贤纳士',
        component: SinglePage
      },
      {
        path: 'qurCulture',
        name: '文化生活',
        title: '文化生活-招贤纳士',
        component: SinglePage
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./modules/recruitment/routing.js